import { Box, Typography } from "@braintrust/braintrust-ui-components";
import { JobInterviewGradingSummary } from "@js/apps/jobs/components/job-interview-grading-summary";
import type { JobInterviewScorecard } from "@js/types/jobs";
import { capitalize } from "@js/utils";

import { BidInterviewIcon } from "./bid-interview-icon";

export const BidInterviewGrading = ({
  scorecards,
}: {
  scorecards: JobInterviewScorecard[];
}) => {
  return (
    <Box sx={{ mt: 5 }}>
      <Box
        sx={{
          mb: 3,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <BidInterviewIcon />
        <Typography
          component="h2"
          variant="paragraph"
          size="large"
          sx={{ ml: 1 }}
        >
          Grading Criteria
        </Typography>
      </Box>
      <Box>
        {scorecards.map(({ id, feedback, score, attribute_key }) => (
          <Box
            key={id}
            sx={{
              mb: 4,
              pb: 3,
              borderBottom: "1px solid var(--soft-beige)",
              ":last-child": {
                borderBottomWidth: 0,
              },
            }}
          >
            <JobInterviewGradingSummary
              grade={score}
              title={capitalize(attribute_key.toLowerCase())}
              description={feedback}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
